/**
 * 新增月度对账 新增页面 表单配置处理
 * @author zjs
 * @time 2023-04-24
 */
export default {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "计划月份",
                type: "LyDatePicker",
                field: "month_plan",
                json: {
                    type: 'month'
                },
                default: ""
            }, {
                name: "计划应收",
                type: "LyInputNumber",
                field: "yingshou_plan",
                width: '220px',
                json: {
                    min: 0
                },
                default: ""
            }]
        }
    }
}